import type { SalonSlug } from "@/data/types";

const KEY = "tb:lastBooking:v1";
const MAX_AGE_MS = 90 * 24 * 60 * 60 * 1000; // 90 days

export interface LastBooking {
  salonSlug: SalonSlug;
  salonName: string;
  barberName?: string;
  serviceName?: string;
  bookingUrl: string;
  timestamp: number;
}

export function recordLastBooking(entry: Omit<LastBooking, "timestamp">) {
  if (typeof window === "undefined") return;
  try {
    const data: LastBooking = { ...entry, timestamp: Date.now() };
    window.localStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    // ignore (private mode, quota, etc.)
  }
}

export function getLastBooking(): LastBooking | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as LastBooking;
    if (!parsed.timestamp || !parsed.bookingUrl) return null;
    if (Date.now() - parsed.timestamp > MAX_AGE_MS) {
      window.localStorage.removeItem(KEY);
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearLastBooking() {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
